import './styles.scss';

import { FocusEvent, ForwardedRef, KeyboardEvent, ReactElement, forwardRef } from 'react';

import { FormatInputTypes } from '@/common/FormatInput/types';
import InputBase from '@/common/Input/InputBase';
import { getClasses } from '@/utils';
import useForwardRef from '@/hooks/useForwardRef';

const FormatInput = forwardRef<FormatInputTypes.RefType, FormatInputTypes.Props>(
  ({ onFormat, ...props }: FormatInputTypes.Props, ref: ForwardedRef<FormatInputTypes.RefType>): ReactElement => {
    const inputRef = useForwardRef(ref);

    return (
      <InputBase
        {...props}
        className={getClasses('FormatInput', 'Common', props.className)}
        onBlur={(value: string, event: FocusEvent<HTMLInputElement>): void => {
          event.target.value = onFormat?.(value) ?? value;
          props?.onBlur?.(event.target.value, event);
        }}
        onEnter={(value: string, event: KeyboardEvent<HTMLInputElement>): void => {
          inputRef.current?.blur?.();
          props.onEnter?.(value, event);
        }}
        ref={inputRef}
      />
    );
  }
);
FormatInput.displayName = 'FormatInput';

export default FormatInput;
